import React, { useState, useEffect } from "react";
import { Checkbox, FlexboxGrid, Table as _Table, Alert } from "rsuite";
import styled from "styled-components";

import { canIMoveNumbersToAnyTrunk } from "utils"
import { Spacer } from "components/base/Spacer";
import {
    ButtonPrimary as Add, ButtonRowAllocate, ButtonRowDelete, ButtonRowUpload,
    ButtonRowDownload, ButtonRowEdit, ButtonRowRevoke
} from "components/base/BaseButton";
import Table from "components/Table/Table";

import UploadSupplierPrefixModal from "./UploadSupplierPrefixModal/UploadSupplierPrefixModal";
import UploadGanNumbersModal from "./UploadGanNumbersModal/UploadGanNumbersModal";
import ModalUploadResult from "./UploadGanNumbersModal/ModalUploadResult";

import TrunkModal from "./TrunkModal/TrunkModal/TrunkModalRefactored";
import SupplierTrunkModal from "./SupplierTrunkModal/TrunkModal/TrunkModalRefactored";
import RevokeTrunkModal from "./RevokeTrunkModal";
import RemoveTrunkModal from "./RemoveTrunkModal";
import { Header, HeaderTrunkActions } from "./styled";
import { checkPermissionsFor } from "store/storeHelpers";
import {
    SMS_SUPPLIER_TRUNK_CREATE_METHOD,
    SMS_SUPPLIER_TRUNK_REMOVE_METHOD,
    SMS_SUPPLIER_TRUNK_MODIFY_METHOD,
    SMS_SUPPLIER_PREFIX_UPLOAD_CSV_METHOD,
    SMS_SUPPLIER_GAN_GROUP_UPLOAD_CSV_NEW_METHOD,
    SMS_SUPPLIER_PLAN_CREATE_METHOD,
    SMS_SUPPLIER_PLAN_MODIFY_METHOD,
    SMS_SUPPLIER_PLAN_REMOVE_METHOD,
    TRUNK_CREATE_SMS_API,
    TRUNK_CREATE_API,
    TRUNK_MODIFY_SMS_API,
    TRUNK_MODIFY_API,
    TRUNK_REMOVE_SMS_API,
    TRUNK_REMOVE_API,
    ALLOCATION_TEMPLATE_API,
    SMS_ALLOCATION_TEMPLATE_API,
    TRUNK_REVOKE_ALL_NUMBERS_API,
    SMS_TRUNK_REVOKE_ALL_NUMBERS_API
} from "const/apiMethods";

const { Column, HeaderCell, Cell } = _Table;


const Trunks = ({
    trunks,
    account,
    acc_key,
    service,
    columns,
    isMobile,
    ivr_list,
    trunk_id,
    activeTab,
    savedParams,
    isGanTrunks,
    ipOptionList,
    supplierList,
    account_name,
    trunksLoading,
    mobileColumns,
    currentTrunkId,
    isTransitTrunks,
    currentSupplier,
    closedTrunksShow,
    paymentTermsList,
    rerouteStatusList,
    suppliersPlanList,
    supplierPriceList,
    transitDefaultLimit,
    accountServicePlanList,
    allocatedNumbersLoading,

    setTrunk,
    getTrunks,
    getNumbers,
    getSuppliers,
    showReasonHandler,
    onAllocateNumbers,
    setCurrentTrunkId,
    createTrafficLimit,
    modifyTrafficLimit,
    removeTrafficLimit,
    setClosedTrunksShow,
    trunkDownloadNumbers,
    setCurrentRangeNumber,
    getSupplierPriceList
}) => {

    const [currentTop, setCurrentTop] = useState(0);
    const [data, setData] = useState([]);
    const [currentTrunkData, setCurrentTrunkData] = useState({});
    const [modalResultData, setModalResultData] = useState(null);
    const [showEditTrunkModal, setShowEditTrunkModal] = useState(false);
    const [showRemoveTrunkModal, setShowRemoveTrunkModal] = useState(false);
    const [showRevokeTrunkModal, setShowRevokeTrunkModal] = useState(false);
    const [showManageSupplierPlanModal, setShowManageSupplierPlanModal] = useState(false);
    const [showUploadPrefixTrunkModal, setShowUploadPrefixTrunkModal] = useState(false);
    const [showUploadGanNumbersModal, setShowUploadGanNumbersModal] = useState(false);
    const [showResultModal, setShowResultModal] = useState(false);

    useEffect(() => {
        const columnHeight = 30;

        const trunksList = trunks.filter((trunk) => {
            return closedTrunksShow ? true : !trunk.closed
        });

        let top;

        if (!currentTrunkId)
            top = Math.abs(currentTop);
        else {
            top = Math.abs((trunksList.map(trunk => trunk.id).indexOf(currentTrunkId) || 0) * columnHeight);
        }

        setCurrentTop(top);
        setData(trunksList);
    }, [trunks, closedTrunksShow]);

    const handleClickTrunk = (id) => {
        setTrunk(id);
        setCurrentRangeNumber(null)
    };

    const showTrunk = () => {
        setShowEditTrunkModal(true);
        setCurrentTrunkData({});
    };

    const onDownloadNumbers = async (id) => {

        setData(data.map(
            trunk => ({
                ...trunk,
                downloadLoading: trunk.id === id
                    ? true
                    : trunk.downloadLoading
            })
        ));

        const plan_type = isTransitTrunks ? "transit" : isGanTrunks ? "gan" : undefined;

        trunkDownloadNumbers(id, service, plan_type, currentSupplier?.supplier_id);

        setData(() => {
            return data.map(
                trunk => ({
                    ...trunk,
                    downloadLoading: trunk.id === id ? false : trunk.downloadLoading
                })
            )
        });
    };

    const onEditTrunk = (rowData) => {
        const endDate = rowData.end_date
            ? new Date(rowData.end_date)
            : null;

        setShowEditTrunkModal(true);
        setCurrentTrunkData({
            ...rowData,
            end_date: endDate
                ? new Date(
                    endDate.getFullYear(),
                    endDate.getMonth(),
                    endDate.getDate(),
                    endDate.getHours(),
                    endDate.getMinutes(),
                    endDate.getSeconds() - 1
                )
                : null
        });
    };


    const onRevokeTrunk = () => {
        setShowRevokeTrunkModal(true);
    };


    const onRemoveTrunk = (rowData) => {
        setShowRemoveTrunkModal(true);
        setCurrentTrunkData({ ...rowData });
    };

    const onUploadPrefixes = (rowData) => {
        if (isTransitTrunks) {
            setShowUploadPrefixTrunkModal(true);
            setCurrentTrunkData({ ...rowData });
        } else if (isGanTrunks) {
            setShowUploadGanNumbersModal(true);
            setCurrentTrunkData({ ...rowData });
        }

    };

    const transformedData = data.map(item => {
        return {
            ...item,
            start_date: item.start_date ? item.start_date.replace(" ", "T") : "",
            end_date: item.end_date ? item.end_date.replace(" ", "T") : "",
        }
    });

    const isSuppliersTrunks = (isGanTrunks || isTransitTrunks);

    const currentTrunk = trunks.find((trunk) => trunk.id === trunk_id);
    const createTrunkMethod = service ? TRUNK_CREATE_API : TRUNK_CREATE_SMS_API;
    const showCreateTrunkButton = (isSuppliersTrunks
        ? checkPermissionsFor(SMS_SUPPLIER_TRUNK_CREATE_METHOD)
        : checkPermissionsFor(createTrunkMethod)
    );
    const removeTrunkMethod = service ? TRUNK_REMOVE_API : TRUNK_REMOVE_SMS_API;
    const showRemoveTrunkButton = (isSuppliersTrunks
        ? checkPermissionsFor(SMS_SUPPLIER_TRUNK_REMOVE_METHOD)
        : checkPermissionsFor(removeTrunkMethod)
    );
    const modifyTrunkMethod = service ? TRUNK_MODIFY_API : TRUNK_MODIFY_SMS_API;
    const showModifyTrunkButton = (isSuppliersTrunks
        ? checkPermissionsFor(SMS_SUPPLIER_TRUNK_MODIFY_METHOD)
        : checkPermissionsFor(modifyTrunkMethod)
    );
    const allocateTrunkMethod = service ? ALLOCATION_TEMPLATE_API : SMS_ALLOCATION_TEMPLATE_API;
    const showAllocateTrunkButton = checkPermissionsFor(allocateTrunkMethod);
    const revokeTrunkMethod = service ? TRUNK_REVOKE_ALL_NUMBERS_API : SMS_TRUNK_REVOKE_ALL_NUMBERS_API;
    const showRevokeTrunkButton = checkPermissionsFor(revokeTrunkMethod);

    const canUploadTransitNumbers = checkPermissionsFor(SMS_SUPPLIER_PREFIX_UPLOAD_CSV_METHOD);
    const showUploadTransitNumbersButton = isTransitTrunks && canUploadTransitNumbers;
    const canUploadGanNumbers = checkPermissionsFor(SMS_SUPPLIER_GAN_GROUP_UPLOAD_CSV_NEW_METHOD);
    const showUploadGanNumbersButton = isGanTrunks && canUploadGanNumbers;
    const showManageTrunkTypeButton = (isGanTrunks || isTransitTrunks) && checkPermissionsFor(SMS_SUPPLIER_PLAN_CREATE_METHOD);
    const showModifyTrunkTypeButton = (isGanTrunks || isTransitTrunks) && checkPermissionsFor(SMS_SUPPLIER_PLAN_MODIFY_METHOD);
    const showRemoveTrunkTypeButton = (isGanTrunks || isTransitTrunks) && checkPermissionsFor(SMS_SUPPLIER_PLAN_REMOVE_METHOD);

    const headers = {
        "trunks": "Trunks",
        "gan_trunks": "GAN Trunks",
        "transit_trunks": "Transit Trunks",
        "default": "Trunks"
    };

    const defaultActionCells = ActionCell(
        showModifyTrunkButton ? onEditTrunk : null,
        onDownloadNumbers,
        showAllocateTrunkButton ? onAllocateNumbers : null,
        showRevokeTrunkButton ? onRevokeTrunk : null,
        showRemoveTrunkButton ? onRemoveTrunk : null
    );

    const supplierActionCells = ActionCell(
        showModifyTrunkButton ? onEditTrunk : null,
        onDownloadNumbers,
        null,
        null,
        showRemoveTrunkButton ? onRemoveTrunk : null,
        showUploadTransitNumbersButton || showUploadGanNumbersButton ? onUploadPrefixes : null,
        isSuppliersTrunks
    );

    const actionCells = (isGanTrunks || isTransitTrunks) ? supplierActionCells : defaultActionCells;

    const filteredSupplierPlanList = suppliersPlanList && suppliersPlanList.length
        ? suppliersPlanList.filter(supplier => {
            return isTransitTrunks ? supplier.type === "transit" :
                isGanTrunks ? supplier.type === "gan" : true
        }) : [];

    const isSupplierTrunks = isGanTrunks || isTransitTrunks;

    return (<div>
        <Spacer size={10} />
        <FlexboxGrid align={"middle"}>


            {!isMobile &&
                <FlexboxGrid.Item>
                    <Header>{headers[activeTab] || headers["default"]}</Header>
                </FlexboxGrid.Item>
            }


            <FlexboxGrid.Item style={{ marginLeft: "auto" }}>
                <FlexboxGrid align={"middle"}>

                    {!isMobile &&
                        <FlexboxGrid.Item>
                            <StyledFilter>
                                <Checkbox
                                    onClick={setClosedTrunksShow}
                                />
                                <span>Show closed trunks</span>
                            </StyledFilter>
                        </FlexboxGrid.Item>
                    }

                    {showCreateTrunkButton && <FlexboxGrid.Item>
                        <HeaderTrunkActions>
                            <Add onClick={showTrunk}>+Add New Trunk</Add>
                        </HeaderTrunkActions>
                    </FlexboxGrid.Item>}

                </FlexboxGrid>
            </FlexboxGrid.Item>
        </FlexboxGrid>


        {showEditTrunkModal && !isSupplierTrunks &&
            <TrunkModal
                isGanTrunks={isGanTrunks}
                isTransitTrunks={isTransitTrunks}
                accountServicePlanList={accountServicePlanList}
                initialValues={currentTrunkData}
                ipOptionList={ipOptionList}
                ivr_list={ivr_list}
                account_id={acc_key}
                account={account}
                account_name={account_name}
                update={(extraUpdate = false) => {
                    const isSuppliersTrunks = (isGanTrunks || isTransitTrunks);
                    const updateNumbers = !isSuppliersTrunks;
                    getTrunks(updateNumbers || extraUpdate);
                }}
                trunksList={trunks}
                service={service}
                transitDefaultLimit={transitDefaultLimit}
                currentSupplier={currentSupplier}
                rerouteStatusList={rerouteStatusList}
                onClose={() => setShowEditTrunkModal(false)}
                createTrafficLimit={createTrafficLimit}
                modifyTrafficLimit={modifyTrafficLimit}
                removeTrafficLimit={removeTrafficLimit}
            />
        }
        {showEditTrunkModal && isSupplierTrunks &&
            <SupplierTrunkModal
                isGanTrunks={isGanTrunks}
                isTransitTrunks={isTransitTrunks}
                accountServicePlanList={accountServicePlanList}
                initialValues={currentTrunkData}
                ipOptionList={ipOptionList}
                account_id={acc_key}
                account={account}
                account_name={account_name}
                update={(extraUpdate = false) => {
                    const isSuppliersTrunks = (isGanTrunks || isTransitTrunks);
                    const updateNumbers = !isSuppliersTrunks;
                    getTrunks(updateNumbers || extraUpdate);
                }}
                trunksList={trunks}
                transitDefaultLimit={transitDefaultLimit}
                currentSupplier={currentSupplier}
                suppliersPlanList={filteredSupplierPlanList}
                supplierPriceList={supplierPriceList}
                rerouteStatusList={rerouteStatusList}
                paymentTermsList={paymentTermsList}
                onClose={() => setShowEditTrunkModal(false)}
                createTrafficLimit={createTrafficLimit}
                modifyTrafficLimit={modifyTrafficLimit}
                removeTrafficLimit={removeTrafficLimit}
                getSupplierPriceList={getSupplierPriceList}
            />
        }

        {showUploadPrefixTrunkModal &&
            <UploadSupplierPrefixModal
                show={showUploadPrefixTrunkModal}
                currentTrunkData={currentTrunkData}
                currentSupplier={currentSupplier}
                onSuccess={(response) => {
                    const inserted = response["supplier_prefixes"]?.inserted || 0;
                    const updated = response["supplier_prefixes"]?.updated || 0;
                    const count = inserted + updated;

                    Alert.success(`Trunk ${count} prefixes has been uploaded`);

                    setShowUploadPrefixTrunkModal(false);
                    getNumbers(savedParams?.group, savedParams?.filter, savedParams?.page, savedParams?.per_page, savedParams?.sort);
                }}
                onClose={() => {
                    setShowUploadPrefixTrunkModal(false);
                }}
            />
        }

        {showUploadGanNumbersModal &&
            <UploadGanNumbersModal
                show={showUploadGanNumbersModal}
                trunks={trunks}
                service={service}
                supplierList={supplierList}
                getSuppliers={getSuppliers}
                currentTrunkId={currentTrunkId}
                currentSupplier={currentSupplier}
                showReasonHandler={showReasonHandler}
                onSuccess={(response) => {
                    // Alert.success(`Trunk ${response["uploaded_numbers"]} prefixes has been uploaded`);    
                    setShowUploadGanNumbersModal(false);

                    if (!("error" in response)) {
                        setModalResultData({
                            ...response
                        });
                        setShowResultModal(true);
                    }

                    getNumbers(savedParams?.group, savedParams?.filter, savedParams?.page, savedParams?.per_page, savedParams?.sort);
                }}
                onClose={() => {
                    setShowUploadGanNumbersModal(false);
                }}
            />
        }

        {showResultModal &&
            <ModalUploadResult
                show={showResultModal}
                data={modalResultData}
                onClose={() => setShowResultModal(false)}
                onExited={() => setModalResultData(null)}
            />
        }

        <Table
            active_id={trunk_id}
            data={transformedData}
            columns={!isMobile ? columns : mobileColumns}
            loading={trunksLoading || allocatedNumbersLoading}
            rowHeight={!isMobile ? 30 : 50}
            shouldUpdateScroll={false}
            rowClassName={(rowData) => rowData && rowData.closed
                ? "closed-row"
                : (rowData && !rowData.active) ? "row-disabled" : ""
            }

            ActionCell={actionCells}
            onRowClick={handleClickTrunk}
        />


        {showRevokeTrunkModal &&
            <RevokeTrunkModal
                service={service}
                account_id={acc_key}
                trunk_id={trunk_id}
                onClose={() => setShowRevokeTrunkModal(false)}
                update={() => getTrunks(true)}
            />
        }


        {showRemoveTrunkModal &&
            <RemoveTrunkModal
                service={service}
                account_id={acc_key}
                trunk_id={trunk_id}
                data={currentTrunkData}
                isSupplierTrunks={isSupplierTrunks}
                trunkList={data.filter(trunk => canIMoveNumbersToAnyTrunk(currentTrunk, trunk))}
                onClose={() => setShowRemoveTrunkModal(false)}
                update={() => {
                    // const isSuppliersTrunks = (isGanTrunks || isTransitTrunks);
                    const updateNumbers = false;

                    getTrunks(updateNumbers);
                    setCurrentTrunkId(null);
                }}
            />
        }


    </div>);
};


const ActionCell = (edit, download, allocate, revoke, remove, uploadPrefix, isSupplier = null) => (
    <Column width={isSupplier ? 140 : 172}>
        <HeaderCell>Actions</HeaderCell>
        <Cell>
            {rowData => (
                <StyledActionCell>

                    {edit && <ButtonRowEdit
                        onClick={() => edit(rowData)}
                        mr={8}
                    />}

                    {download && <ButtonRowDownload
                        loading={rowData.downloadLoading}
                        onClick={() => download(rowData.id)}
                        mr={8}
                    />}

                    {allocate ? rowData.incorporated
                        ? <ButtonRowAllocate
                            tooltipText="You cannot allocate global access numbers from here"
                            tooltipPlacement="left"
                            disabled={true}
                            mr={8}
                        />
                        : <ButtonRowAllocate
                            disabled={rowData.closed || !rowData.active}
                            onClick={() => allocate(rowData.id)}
                            mr={8}
                        />
                        : <></>}

                    {revoke && <ButtonRowRevoke
                        onClick={() => revoke(rowData.id)}
                        mr={8}
                    />}

                    {(rowData.custom_ranges || rowData.type === "gan") && uploadPrefix && <ButtonRowUpload
                        onClick={() => uploadPrefix(rowData)}
                        mr={8}
                    />}

                    {remove && <ButtonRowDelete
                        onClick={() => remove(rowData)}
                        mr={0}
                    />}

                </StyledActionCell>
            )}
        </Cell>
    </Column>
);

export default Trunks;

const StyledFilter = styled.div.attrs(props => ({
    className: "",
}))`
    align-items: center !important;
    display: flex !important;
    padding-right: 20px;
`;

const StyledActionCell = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
`;